export const getEventPositionStyle = (event) => (
    {
        'top': `${event.view.positionTop}px`,
        'left': `${event.view.positionLeft}%`,
        'height': `${event.view.height}px`,
        'width': `${event.view.width}%`,
        'position': 'absolute',
    }
);
